import React from 'react';
import { useTable, usePagination } from 'react-table';

function MetadataTable(props: any) {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Form Number',
        accessor: 'form_number',
      },
      {
        Header: 'Form Title',
        accessor: 'form_title',
      },
      {
        Header: 'Form Type',
        accessor: 'form_type',
      },
      {
        Header: 'Form Summary',
        accessor: 'explanation_of_impact',
      },
      {
        Header: 'Underwriting Guidance',
        accessor: 'form_usage_rule',
      },
      {
        Header: 'Impact on Coverage',
        accessor: 'impact_on_coverage',
      },
      {
        Header: 'Variable/Static',
        accessor: 'variable_static',
      },
      {
        Header: 'Line of Business Policy Details',
        accessor: 'line_of_business_policy_details',
      },
      {
        Header: 'Form Source',
        accessor: 'form_source',
      },
      {
        Header: 'Usage Category',
        accessor: 'form_usage_category',
      },
      {
        Header: 'Premium Bearing',
        accessor: 'premium_bearing',
      },
      {
        Header: 'Premium Info',
        accessor: 'premium_info',
      },
      {
        Header: 'Form Status',
        accessor: 'form_status',
      },
      {
        Header: 'Requested Effective Date',
        accessor: 'requested_effective_date',
      },
      {
        Header: 'Business Unit',
        accessor: 'bu',
      },
      {
        Header: 'Operating Unit',
        accessor: 'opu',
      },
      {
        Header: 'Program or Product',
        accessor: 'program_or_product',
      },
      {
        Header: 'Line of Business',
        accessor: 'line_of_business',
      },
      {
        Header: 'Carrier',
        accessor: 'carrier',
      },
      {
        Header: 'States',
        accessor: 'states',
      },
    ],
    []
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    { columns, data: props.data },
    usePagination
  );

  return (
    <table {...getTableProps()} style={{ borderSpacing: '0', fontSize: '12px', marginTop: '16px' }}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th
                {...column.getHeaderProps()}
                style={{
                  background: '#ddd',
                  color: 'black',
                  padding: '2px 10px',
                  fontWeight: 'bold',
                }}
              >
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    style={{
                      padding: '10px',
                      border: 'solid 0.5px #ccc',
                      minWidth: '150px',
                    }}
                  >
                    {cell.render('Cell')}
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

export default MetadataTable;
